var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"index_body"}},[_c('FileManager',{attrs:{"apiUrl":_vm.vourusUrl,"password":this.auth,"username":this.username,"language":"de"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }